import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Input, InputGroup, FormGroup, Form, Row, Col, Table } from 'reactstrap';
import { Translate, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IDonViHanhChinh } from 'app/shared/model/don-vi-hanh-chinh.model';
import { searchEntities, getEntities } from './don-vi-hanh-chinh.reducer';

export const DonViHanhChinh = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const [search, setSearch] = useState('');

  const donViHanhChinhList = useAppSelector(state => state.donViHanhChinh.entities);
  const loading = useAppSelector(state => state.donViHanhChinh.loading);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  const startSearching = e => {
    if (search) {
      dispatch(searchEntities({ query: search }));
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  const { match } = props;

  return (
    <div>
      <h2 id="don-vi-hanh-chinh-heading" data-cy="DonViHanhChinhHeading">
        <Translate contentKey="xtdtApp.donViHanhChinh.home.title">Don Vi Hanh Chinhs</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="xtdtApp.donViHanhChinh.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/don-vi-hanh-chinh/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="xtdtApp.donViHanhChinh.home.createLabel">Create new Don Vi Hanh Chinh</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('xtdtApp.donViHanhChinh.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {donViHanhChinhList && donViHanhChinhList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="xtdtApp.donViHanhChinh.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.donViHanhChinh.ten">Ten</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.donViHanhChinh.ma">Ma</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.donViHanhChinh.cap">Cap</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.donViHanhChinh.geometry">Geometry</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.donViHanhChinh.thongTinChung">Thong Tin Chung</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.donViHanhChinh.cha">Cha</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {donViHanhChinhList.map((donViHanhChinh, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/don-vi-hanh-chinh/${donViHanhChinh.id}`} color="link" size="sm">
                      {donViHanhChinh.id}
                    </Button>
                  </td>
                  <td>{donViHanhChinh.ten}</td>
                  <td>{donViHanhChinh.ma}</td>
                  <td>{donViHanhChinh.cap}</td>
                  <td>{donViHanhChinh.geometry}</td>
                  <td>
                    {donViHanhChinh.thongTinChung ? (
                      <Link to={`/thong-tin-dia-phuong/${donViHanhChinh.thongTinChung.id}`}>{donViHanhChinh.thongTinChung.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {donViHanhChinh.cha ? <Link to={`/don-vi-hanh-chinh/${donViHanhChinh.cha.id}`}>{donViHanhChinh.cha.id}</Link> : ''}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/don-vi-hanh-chinh/${donViHanhChinh.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/don-vi-hanh-chinh/${donViHanhChinh.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/don-vi-hanh-chinh/${donViHanhChinh.id}/delete`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="xtdtApp.donViHanhChinh.home.notFound">No Don Vi Hanh Chinhs found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default DonViHanhChinh;
